export const SENTRY_RELEASE: string | undefined = 'f6c606cc635ee88081047b0c13313d05665411e6';
